module.exports = __webpack_public_path__ + "static/media/socketPipesImage.5a5b9020.jpg";